// The brand every template in this folder is bound to. Swapping brands means a
// sibling folder, not a runtime flag — same idea as the ccd/cld/vcd folders in
// server/src/utils/aws-email-sender/templates.

import { BRANDS } from "../brands";

export const brand = BRANDS.MIND_YOUR_BUSINESS;
